var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80877 7.90025C7.80877 5.47443 8.59086 3.22095 9.90319 1.37839C4.75993 2.41234 0.875977 6.94583 0.875977 12.394C0.875977 18.5977 5.89993 23.6216 12.1037 23.6216C15.8683 23.6216 19.1955 21.7658 21.2237 18.9158C20.5078 19.0616 19.7788 19.1279 19.0232 19.1279C12.8195 19.1279 7.79551 14.104 7.79551 7.90025H7.80877Z",
    stroke: "#001942",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeIcon);
export default __webpack_public_path__ + "static/media/darkModeIcon.0638c4cb965d3003445f1fb6465a3c81.svg";
export { ForwardRef as ReactComponent };